













































import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Swiper as SwiperClass, Pagination, Mousewheel } from "swiper";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Prop, Watch, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

// Swiper modules
SwiperClass.use([Pagination, Mousewheel]);

@Component({
  components: {
    Swiper,
    SwiperSlide,
    IconBase,
    IconArrowLeft,
    IconArrowRight
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheC01ItemThumbnailsSp extends Vue {
  @Prop({ type: Array, required: true, default: () => [] }) thumbnails!: any;
  colorCode!: string;

  main = "";
  swiperOption = {
    loop: true,
    speed: 350,
    pagination: {
      el: ".js-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".js-button-next",
      prevEl: ".js-button-prev"
    }
  };

  get haveThumnails() {
    return this.thumbnails.length > 0;
  }

  @Watch("thumbnails")
  onThumbnails() {
    this.initMain();
  }

  selectSub(sub: any) {
    this.main = sub;
  }
  selectedStyle(sub: any) {
    return this.main === sub ? `border: 1px solid ${this.colorCode}` : "";
  }
  initMain() {
    this.main = this.haveThumnails ? this.thumbnails[0] : {};
  }
}
